import StatusChip from "../shared/StatusChip";
import { ApplicationWithId } from "../../interfaces/IApplications";
import { Box, Typography } from "@mui/material";

interface ApplicationStatusProps {
  application: ApplicationWithId;
}

export default function ApplicationStatus({ application }: ApplicationStatusProps) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }}>
        Status:
      </Typography>
      <StatusChip type="application" value={application.status} size="small" />
    </Box>
  );
}
